import { useState, useEffect } from 'react';

export function useLogoAnimation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollY = window.pageYOffset;
          // Start animation immediately on any scroll (1px threshold)
          const threshold = 1;
          const shouldBeScrolled = scrollY > threshold;
          
          // Calculate smooth progress for enhanced animation
          const maxScroll = 150; // Distance over which to complete the animation
          const progress = Math.min(scrollY / maxScroll, 1);
          setScrollProgress(progress);
          
          if (shouldBeScrolled !== isScrolled) {
            setIsScrolled(shouldBeScrolled);
          }
          
          ticking = false;
        });
        ticking = true;
      }
    };

    // Use passive listener for maximum performance
    window.addEventListener('scroll', handleScroll, { 
      passive: true,
      capture: false 
    });
    
    // Check initial state
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isScrolled]);

  const scrollToTop = () => {
    window.scrollTo({ 
      top: 0, 
      behavior: 'smooth' 
    });
  };

  return {
    isScrolled,
    scrollProgress,
    scrollToTop
  };
}